import { http } from '@/core/http/client'
import type { MenuRouteDto } from '@/models/auth'

export interface AuthSecret {
  publicKey: string
  flag: string
}

export function getAuthSecret() {
  return http.get<AuthSecret>('/auth/secret')
}

export interface AuthRole {
  roleId: string | number
  roleName?: string
  roleKey?: string
  isSuperAdmin?: boolean
}

export interface AuthLoginResponse {
  userId: string | number
  username: string
  tokenName: string
  tokenValue: string
  needModify: boolean
  version?: string
  roles: AuthRole[]
}

export function login(payload: string, encryptFlag: string) {
  return http.post<AuthLoginResponse>('/auth/login', payload, {
    headers: { UUID: encryptFlag },
    transformRequest: [(data) => data]
  })
}

export function fetchMenu() {
  return http.get<MenuRouteDto[]>('/auth/menus')
}

export function logout() {
  return http.post('/auth/logout')
}

export function updatePassword(payload: unknown, encryptFlag?: string) {
  return http.put('/sysUser/update/password', payload, {
    headers: { UUID: encryptFlag },
    transformRequest: [(data) => data]
  })
}

export function getLicenseDays() {
  return http.get<{ flag?: boolean; days?: number }>('/license/days')
}

export interface LicenseAbout {
  version?: string
  expiryDate?: string
}

export function getLicenseAbout() {
  return http.get<LicenseAbout>('/license/about')
}

export function importLicense(payload: FormData) {
  return http.uploadPostResult('/license/import', payload)
}
